'use client';

import Image from 'next/image';
import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FeatureHero from '../_shared/sections/FeatureHero';

type Props = { lang: Locale };

const LOGIN_PAGE_IMAGE = 'https://cdn.1cdn.app/application/UMD/26050409230160_login_page_sum.png';

const LoginPageHero = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const visual = (
    <Image
      src={LOGIN_PAGE_IMAGE}
      alt={t('LoginPage/Hero/visual_alt')}
      width={1200}
      height={900}
      sizes="(min-width: 1024px) 360px, 60vw"
      className="mx-auto h-auto w-3/4 max-w-[315px] rounded-2xl lg:w-full lg:max-w-[480px]"
      priority
    />
  );

  return (
    <FeatureHero
      accent="#A78BFA"
      ariaLabel={t('LoginPage/Hero/aria_label')}
      copy={{
        kicker: t('LoginPage/Hero/badge'),
        headlineA: t('LoginPage/Hero/title1'),
        headlineB: t('LoginPage/Hero/title2'),
        subhead: t('LoginPage/Hero/subtitle'),
        ctaPrimary: {
          label: t('LoginPage/Hero/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('LoginPage/Hero/cta_secondary'),
          href: '#how-it-works',
        },
      }}
      visual={visual}
      visualVisibleOnMobile
    />
  );
};

export default LoginPageHero;
